import { useTheme } from "@mui/material";
import Typography from "components/basic/typography";

interface ReviewRowProps {
  label: string;
  value: string;
}

/** A read-only label/value line, styled like the editable rows around it. */
const ReviewRow: React.FC<ReviewRowProps> = ({ label, value }) => {
  const theme = useTheme();

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        borderBottom: `1px solid ${theme.palette.divider}`,
        padding: `${theme.spacing(0.75)} 0`,
      }}
    >
      <Typography variant="body2" style={{ opacity: 0.7 }}>
        {label}
      </Typography>
      <Typography
        variant="body2"
        style={{
          fontWeight: "bold",
          textAlign: "right",
          overflowWrap: "anywhere",
        }}
      >
        {value}
      </Typography>
    </div>
  );
};

export default ReviewRow;
